var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseH2',{staticClass:"modal-header-heading"},[_vm._v(_vm._s(_vm.header))]),(_vm.description)?_c('BaseParagraph',{staticClass:"modal-header-description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),_vm._t("custom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }